import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { filter, map, merge, mergeMap } from 'rxjs';

import { AngularDeviceInformationService } from 'angular-device-information';
import { SessionService } from './common/session.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, MenuComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'versusPay';
  withMenu: boolean = false;
  classMenu='';
  classContent='';
  classProfile='';
  isMobile: boolean = false;
  sessionInfo?: any;
  isVersusPay: boolean;

  constructor(private router:Router,private activeRoute:ActivatedRoute,
    private deviceInfo :AngularDeviceInformationService,
    private session:SessionService
  ) 
  {
    this.isVersusPay = environment.isVersusPay;
  
    if (this.deviceInfo.isMobile()|| this.deviceInfo.isTablet()) {
      this.classMenu ='mt-1';
      this.classContent = 'col-sm-12';
      this.isMobile = true;
    } else {
       this.classMenu ='col-md-3 col-lg-2';
       this.classContent = 'col-md-10 col-lg-11';
       this.classProfile = 'col-md-2 col-lg-1 justify-content-end';
       this.isMobile
    }

  }
    
   ngOnInit(): void {
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd),
    map(() => this.activeRoute),
    map(route => {
      while(route.firstChild){
        route = route.firstChild;
      }
      return route;
    }
    ),
    filter(route => route.outlet === 'primary'),
    mergeMap(route => route.data)
  ).subscribe(data => {
       this.withMenu = data['withMenu'] || false;
       console.log('withMenu:', this.withMenu);
       if(this.withMenu){
         this.sessionInfo = this.session.getSessionInfo();
       }
     
    }
  );
   
  }

  onDeconnect(){

    this.session.deleteSession();
    this.router.navigateByUrl('/login');
  }
}
